import { CustomerQuery, OrderPurpose } from 'lib/graphql/storefront'

export enum SAGA_ARENA_PRODUCT_NAME {
  MAIN = 'メインアリーナ',
  SUB = 'サブアリーナ',
  OTHERS = 'その他',
  VARIOUS_ROOM_141 = '141',
  VARIOUS_ROOM_142 = '142',
}

export enum SAGA_ARENA_USAGE_TYPE {
  EVENT = '催事',
  SETUP_TEARDOWN = '設営・撤去',
  EXTENSION = '延長',
  NO_PERFORMANCE = '休演',
}

export enum SAGA_ARENA_PROFIT_TYPE {
  FOR_PROFIT = '営利',
  NON_PROFIT = '非営利',
}

export enum SUB_ARENA_PROFIT_TYPE {
  FOR_PROFIT = '【営利】',
  NON_PROFIT = '【非営利】',
}

export const SUB_ARENA_BOOKING_TIMEZONE = {
  MORNING: {
    NAME: '午前',
    START: '09:00',
    END: '12:00',
  },
  AFTERNOON: {
    NAME: '午後',
    START: '12:00',
    END: '17:00',
  },
  NIGHT: {
    NAME: '夜間',
    START: '17:00',
    END: '22:00',
  },
  ALLDAY_08: {
    NAME: '12時間',
    START: '08:00',
    END: '20:00',
  },
  ALLDAY_09: {
    NAME: '12時間',
    START: '09:00',
    END: '21:00',
  },
  ALLDAY_10: {
    NAME: '12時間',
    START: '10:00',
    END: '22:00',
  },
}

export const SAGA_ARENA_PURPOSE = {
  SPORTS: 'スポーツ',
  OTHER: 'その他',
  CONCERT: 'コンサート',
}

/* サブアリーナ予約可能フラグを管理する権限 */
export const SUB_ARENA_PERMISSIONS = {
  SUB_ARENA: 'subarena-permitted',
  LOCAL_ORGANIZATION: 'local-organization',
}

/**
 * サブアリーナ予約可能フラグが付与されているかチェックする
 * @param customer 顧客情報
 * @returns boolean
 */
export const canBookSubArena = (customer: CustomerQuery['customer']): boolean =>
  customer &&
  customer.metaFields.edges
    .map(({ node }) => node.key)
    .includes(SUB_ARENA_PERMISSIONS.SUB_ARENA)

/**
 * 県内団体フラグが付与されているかチェックする
 * @param customer 顧客情報
 * @returns boolean
 */
export const isLocalOrganization = (
  customer: CustomerQuery['customer']
): boolean =>
  customer &&
  customer.metaFields.edges
    .map(({ node }) => node.key)
    .includes(SUB_ARENA_PERMISSIONS.LOCAL_ORGANIZATION)

/**
 * 利用目的から文字列を取得する
 */
export const getOrderPurposeString = (purpose: OrderPurpose) => {
  switch (purpose) {
    case 'CONCERT':
      return 'コンサート'
    case 'GENERAL':
      return '一般利用'
    case 'EVENT':
      return 'イベント利用'
    case 'OTHER':
      return 'その他'
    case 'SPORT':
      return 'スポーツ'
    default:
      return null
  }
}

// バリエーション名に「メインアリーナ」または「サブアリーナ」を含む場合は利用目的を除去する
export const removePurposeAndTimeSegment = (subject: string) => {
  if (
    subject.includes(SAGA_ARENA_PRODUCT_NAME.SUB) ||
    subject.includes(SAGA_ARENA_PRODUCT_NAME.MAIN)
  ) {
    const subjectItems = subject.split(' / ')
    return subjectItems[0] + ' / ' + subjectItems[2]
  }
  return subject.split(' / ')[0]
}
